import * as Sentry from '@sentry/browser'
//import { NotificationManager } from 'react-notifications'

//const isLocal = process.env.NODE_ENV === 'development'
const isLocal = false

const SENTRY_DSN = 'https://e7d50cc743a3aeafc6ff6a547e56de83@o290751.ingest.us.sentry.io/4509314632122368'

export function initSentry() {
    if (isLocal) return
    else {
        Sentry.init({ dsn: SENTRY_DSN })
    }
}

export function logError(error, errorInfo = null) {
    if (isLocal) return
    else {
        Sentry.withScope((scope) => {
            errorInfo && scope.setExtras(errorInfo)
            Sentry.captureException(error)
        })
    }
}

export function onError(error) {
    let errorInfo = {}
    let message = error.toString()

    // Auth errors
    if (!(error instanceof Error) && error.message) {
        errorInfo = error
        message = error.message
        error = new Error(message)
    } 
    // API errors
    else if (error.config && error.config.url) {
        errorInfo.url = error.config.url;
    }

    logError(error, errorInfo)

    console.log('ERROR: ', message)
    console.log('error name: ', error.name)
    if (message === 'QuotaExceededError') {
        window.localStorage.clear()
    }
    //NotificationManager.error('Something went wrong. Please try again in few moments.')
}

export function logInvalidSubmission(reason, user = {}, formDetails = {}) {
    if (isLocal) return

    Sentry.captureMessage('Invalid form submission', {
        level: 'warning',
        tags: {
            reason,
            site: formDetails.site || 'unknown'
        },
        extra: {
            reason,
            ...user,
            ...formDetails
        }
    })
}

export function logFormRedirect({ url, site }) {
    if (isLocal) return

    Sentry.captureMessage('Form redirect', {
        level: 'info',
        tags: {
            site: site || 'unknown',
        },
        extra: {
            redirectUrl: url
        }
    })
}